export default "__VITE_ASSET__DyZGCMa7__"